// extracted by mini-css-extract-plugin
export var actionButton = "_6w-1";
export var actionButtons = "_6w-2";
export var actions = "_6w-0";
export var aiUnread = "_6w-10";
export var alignCenter = "_6w-h";
export var backWrapper = "_6w-3";
export var cellContainer = "_6w-4";
export var checkboxContainer = "_6w-5";
export var contentContainer = "_6w-6";
export var contentHeader = "_6w-8";
export var conversationsTableWrapper = "_6w-s";
export var draftReplyBadgeContainer = "_6w-m";
export var dropdownItem = "_6w-b";
export var dropdownItemsContainer = "_6w-a";
export var dropdownTitle = "_6w-c";
export var errorIcon = "_6w-7";
export var filter = "_6w-d";
export var gray = "_6w-i";
export var headerActionButtons = "_6w-e";
export var headerCheckboxContainer = "_6w-f";
export var icon = "_6w-j";
export var menuContainer = "_6w-k";
export var noMoreTicketsIcon = "_6w-12";
export var noMoreTicketsSubText = "_6w-13";
export var oneLine = "_6w-l";
export var optionsButton = "_6w-n";
export var plus = "_6w-o";
export var portalButtonsWrapper = "_6w-g";
export var red = "_6w-p";
export var scrolledTop = "_6w-9";
export var search = "_6w-q";
export var selectedConversationsCount = "_6w-r";
export var spinner = "_6w-t";
export var strong = "_6w-u";
export var summaryCell = "_6w-v";
export var tableContainer = "_6w-11";
export var tagContainer = "_6w-w";
export var threeDots = "_6w-x";
export var twoLines = "_6w-y";
export var unread = "_6w-z";